import { Box, Card, Grid, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import PageContainer from "src/components/container/PageContainer";
import Logo from "src/layouts/full/shared/logo/Logo";
import AuthRegister from "./auth/AuthRegister";

const Register2 = () => {
  return (
    <PageContainer title="Register" description="this is Register page">
      <Box
        sx={{
          position: "absolute",

          background: "radial-gradient(#d2f1df, #d3d7fa, #bad8f4)",
          backgroundSize: "400% 400%",
          animation: "gradient 15s ease infinite",
          height: "150%",
          minHeight: "700px",
          width: "100%",
          padding: "10px",
        }}
      >
        <Grid
          container
          spacing={0}
          justifyContent="center"
          sx={{ height: "100vh" }}
        >
          <Grid
            item
            xs={12}
            sm={12}
            lg={6}
            xl={5}
            gap={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
          >
            <Card
              elevation={9}
              sx={{ p: 2, zIndex: 1, width: "100%", maxWidth: "500px" }}
            >
              <Box display="flex" alignItems="center" justifyContent="center">
                <Logo />
              </Box>
              <AuthRegister
                subtext={
                  <Typography
                    variant="h5"
                    textAlign="center"
                    color="black"
                    mb={3}
                  >
                    Start Your Affiliate Journey
                  </Typography>
                }
                subtitle={
                  <Stack
                    direction="row"
                    justifyContent="start"
                    spacing={1}
                    mt={3}
                  >
                    <Typography
                      color="textSecondary"
                      variant="h6"
                      fontWeight="400"
                    >
                      Already have an Account?
                    </Typography>
                    <Typography
                      component={Link}
                      to="/auth/login"
                      fontWeight="500"
                      sx={{
                        textDecoration: "none",
                        color: "earnpati.main",
                      }}
                    >
                      Log In
                    </Typography>
                  </Stack>
                }
              />
            </Card>
          </Grid>
        </Grid>
      </Box>
    </PageContainer>
  );
};

export default Register2;
